<template>
  <pnet-validation-observer>
    <div>
      <div class="row">
        <div class="col-md-10">
          <label v-if="azioneScelta.code!='' || isND()">
            <small>{{commFondiValue.name}}</small>
          </label>

          <div v-if="!isND()">
            <!-- 1 TESTO SINGOLO-->
            <text-field v-model="commFondiValue.value" v-if="azioneScelta.code.slice(-1)=='1'"></text-field>

            <!-- 2 3 4 7 FASCE 3 VALORI -->
            <range-values
              :labels="['minC','maxC','valR']"
              v-model="commFondiValue.rangeValues"
              v-if="
                  azioneScelta.code.slice(-1)=='2' || 
                  azioneScelta.code.slice(-1)=='3' || 
                  azioneScelta.code.slice(-1)=='7'"
            ></range-values>

            <range-values
              :labels="['minT','maxT','valR']"
              v-model="commFondiValue.rangeValues"
              v-if="
                  azioneScelta.code.slice(-1)=='4'"
            ></range-values>

            <!-- 5 6 8 FASCE RICORSIVE -->
            <nested-range-values
              v-if="
                  azioneScelta.code.slice(-1)=='5' || 
                  azioneScelta.code.slice(-1)=='6' || 
                  azioneScelta.code.slice(-1)=='8'"
              v-model="commFondiValue.rangeValues"
              :labels="['minT','maxT']"
            ></nested-range-values>

            <!--9 10 NON PRESENTE, CAMPO NOTE-->
            <text-field
              v-model="azioneScelta.description"
              v-if="azioneScelta.code.slice(-1)=='9' || azioneScelta.code.slice(-1)=='0'"
              :readonly="azioneScelta.code.slice(-1)=='9' || azioneScelta.code.slice(-1)=='0'"
            ></text-field>
          </div>
        </div>
      </div>
    </div>
  </pnet-validation-observer>
</template>

<script lang="js">
import Vue from "vue";
import TextField from "@/components/TextField.vue";
import ComboBox from "@/components/ComboBox.vue";
import DatePicker from "@/components/DatePicker.vue";
import RangeValues from "@/components/RangeValues.vue";
import NestedRangeValues from "@/components/NestedRangeValues.vue";
export default Vue.extend({
  props: ["azioneScelta","value","isND"],
  components: {
    TextField,
    ComboBox,
    DatePicker,
    RangeValues,
    NestedRangeValues,
  },
  data: function() {
    return {
      ND : "n.d.",
    }
  },
  methods: {},
  watch: {
    value :{
      deep: true,
      immediate: true,
      handler(){
        this.commFondiValue = this.value;
      }
    },
    commFondiValue: {
      deep: true,
      immediate: true,
      handler(){
        this.$emit('input', this.commFondiValue);
      }
    }
  },
  mounted() {
    this.commFondiValue = this.value;
  }
});
</script>